"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFlag = void 0;
var ComponentFlag;
(function (ComponentFlag) {
    ComponentFlag["New"] = "New";
    ComponentFlag["Deprecated"] = "Deprecated";
})(ComponentFlag || (exports.ComponentFlag = ComponentFlag = {}));
